import React, { useEffect } from "react";

import { FormLogin } from "./styles";
import { ContainerPublic as Container, OverlayPublic as Overlay } from "../../../styles/GlobalStyles";
import Input from "../../../components/Input";
import logoImg from "../../../assets/senai_sidebar.png";
import { Link, useHistory } from "react-router-dom";
import Header from "../../../components/Header";
import { useState } from "react";
import { mascaraCnpj } from "../../../services/utils";
import { useRef } from "react";
import { api } from "../../../services/api";
import { signIn } from "../../../services/security";
import Alerts from "../../../components/Alerts";
import InputPassword from "../../../components/InputPassword";

function Index() {
  const history = useHistory();

  const headerLinks = [
    { label: "Cadastre sua empresa", to: "/cadastrar-empresa" },
    { label: "Admin", to: "/admin" },
  ];

  const btnEnviarRef = useRef();

  const [empresa, setEmpresa] = useState({
    cnpj: "",
    senha: "",
  });

  const [mensagem, setMensagem] = useState(undefined);
  const [loading, setLoading] = useState(false);

  //habilita / desabilita botão
  useEffect(() => {
    const empresaProps = Object.values(empresa);

    let buttonDisabled = true;

    if (empresa.cnpj.length === 18) {
      empresaProps.some((p) => {
        if (p === "") {
          buttonDisabled = true;
          return true;
        }
        buttonDisabled = false;
        return false;
      });
    }

    btnEnviarRef.current.disabled = buttonDisabled;
  }, [empresa]);

  //manipular o loading
  useEffect(() => {
    if (loading) {
      btnEnviarRef.current.disabled = true;
      btnEnviarRef.current.innerHTML = "Verificando...";
    } else {
      btnEnviarRef.current.disabled = false;
      btnEnviarRef.current.innerHTML = "Entrar";
    }
  }, [loading]);

  const handlerCnpj = (e) => {
    setEmpresa({ ...empresa, cnpj: mascaraCnpj(e.target.value) });
  };

  const handlerInput = (e) => {
    setEmpresa({ ...empresa, [e.target.id]: e.target.value });
  };

  const entrar = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const empresaSessao = Object.assign({}, empresa);

      empresaSessao.cnpj = empresaSessao.cnpj.replace(/[^0-9]+/g, "");

      const retorno = await api.post("/sessao/empresas", empresaSessao);

      signIn(retorno.data);

      history.push("/empresa/home");
    } catch (e) {
      if (e.response) {
        setEmpresa({ ...empresa, senha: "" });
        setLoading(false);
        document.querySelector("#senha").focus();
        return setMensagem({
          show: true,
          titulo: "Erro",
          detalhe: e.response.data.erro,
        });
      }
      setLoading(false);
      setMensagem({
        show: true,
        titulo: "Erro",
        detalhe: "Erro no servidor, tente novamente mais tarde.",
      });
    }
  };

  return (
    <Container>
      <Alerts mensagem={mensagem} setMensagem={setMensagem} tipo="erro" />
      {/* <Overlay /> */}
      <Header links={headerLinks} />
      <FormLogin onSubmit={entrar}>
        <header>
          <img src={logoImg} alt="Logo do Senai" />
        </header>
        <section>
          <h1>Bem-vindo ao SENAI Job</h1>
          <Input
            type="text"
            placeholder="99.999.9999/0009-99"
            label="CNPJ"
            maxLength={18}
            value={empresa.cnpj}
            handler={handlerCnpj}
            required
          />
          <InputPassword
            id="senha"
            type="password"
            placeholder="* * * * * *"
            label="Senha"
            value={empresa.senha}
            handler={handlerInput}
            required
          />
          <button ref={btnEnviarRef}>Entrar</button>
          <Link to="/redefinir-senha">Esqueceu sua senha?</Link>
          <button
            type="button"
            onClick={() => history.push("/cadastrar-empresa")}
            style={{
              backgroundColor: "transparent",
              border: "2px solid var(--primary)",
              color: "var(--primary)",
              marginTop: 20,
            }}
          >
            Cadastre sua empresa
          </button>
        </section>
      </FormLogin>
    </Container>
  );
}

export default Index;
